import React from 'react';
import PropTypes from 'prop-types';

import WordPressContent from './WordPressContent';

import './WordPressPostContent.css';

const propTypes = {
  content: PropTypes.string.isRequired,
};

const defaultProps = {

};

function WordPressPostContent({ content }) {
  return (
    <div className="wordpress-post-content">
      <WordPressContent content={content} />
    </div>
  );
}

WordPressPostContent.propTypes = propTypes;
WordPressPostContent.defaultProps = defaultProps;

export default WordPressPostContent;
